import PropTypes from "prop-types";
import {LightBulbIcon} from "@heroicons/react/24/outline";
import {useState, useEffect} from "react";
import {XMarkIcon} from "@heroicons/react/20/solid";

export default function HorizontalCard(props) {
    const [shouldShowDescription, setShouldShowDescription] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const effectiveSuperSize = isMobile ? false : props.superSizeTitle;

    return (
        <div className="relative">
            {props.imagePosition === "top" && topView()}
            {props.imagePosition === "bottom" && bottomView()}
            {props.imagePosition === "left" && leftView()}
            {props.imagePosition === "right" && rightView()}

            {Boolean(props.description) && (
                <div
                    className="absolute z-10 bottom-8 right-6 lightbulb-btn bg-gray-500 rounded-full p-2 cursor-pointer text-white hover:text-black hover:bg-yellow-200"
                    onClick={() => setShouldShowDescription(!shouldShowDescription)}
                >
                    {shouldShowDescription ? <XMarkIcon className="w-8"/> :
                        <LightBulbIcon className="w-8 hover:color-black"/>}
                </div>
            )}

            {shouldShowDescription && (
                <div
                    className="absolute w-full h-full top-0 rounded-2xl bg-black p-2 cursor-pointer"
                    onClick={() => setShouldShowDescription(false)}
                >
                    <div className="flex items-center justify-center h-full">
                        <div className="text-white w-3/4 space-y-8">
                            <div className="font-semibold text-2xl">{props.title}</div>
                            <div>{props.description}</div>
                        </div>
                    </div>
                </div>
            )}

            <style>
                {`
          @media (max-width: 767px) {
            .vertical-card-inner-h {
              // padding: 2.5rem !important;
            }

            .vertical-card-title-h {
              font-size: 28px !important;
              line-height: 1.3 !important;
            }

            .vertical-card-title-p {
              font-size: 28px !important;
              line-height: 1.3 !important;
              padding: 1rem !important;
            }

            .expanded-mobile-card-h {
              min-height: 550px !important;
            }
          }
        `}
            </style>
        </div>
    );

    function topView() {
        return (
            <div className="bg-white rounded-2xl">
                <div>
                    <img className="object-contain rounded-t-2xl" src={props.imageSource} alt={props.title}
                         style={{width: "100%"}}/>
                </div>
                <div className="flex items-center p-12 pt-4 vertical-card-title-h">
                    <div
                        className="text-8 vertical-card-inner-h"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
            </div>
        );
    }

    function bottomView() {
        return (
            <div className="bg-white rounded-2xl">
                <div className="flex items-center p-12 pb-8 vertical-card-title-p">
                    <div
                        className="text-8 vertical-card-inner-h"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
                <div>
                    <img className="object-contain rounded-b-2xl" src={props.imageSource} alt={props.title}
                         style={{width: "100%"}}/>
                </div>
            </div>
        );
    }

    function leftView() {
        return (
            <div className="flex bg-white rounded-2xl grid grid-cols-3 pr-12">
                <div className="col-span-2 pt-12">
                    <img className="object-contain" src={props.imageSource} alt={props.title}
                         style={{height: "500px", width: "100%"}}/>
                </div>
                <div className="flex items-center col-span-1">
                    <div
                        className="text-8"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
            </div>
        );
    }

    function rightView() {
        return (
            <div className="flex bg-white rounded-2xl grid grid-cols-3 pl-12">
                <div className="flex items-center col-span-1">
                    <div
                        className="text-8"
                        style={{
                            fontWeight: "600",
                            fontSize: effectiveSuperSize ? "64px" : "42px",
                            lineHeight: "1.2",
                        }}
                    >
                        {props.title}
                    </div>
                </div>
                <div className="col-span-2 pt-12">
                    <img
                        className="object-contain object-right rounded-br-2xl"
                        src={props.imageSource}
                        alt={props.title}
                        style={{height: "500px", width: "100%"}}
                    />
                </div>
            </div>
        );
    }
}

HorizontalCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    imageSource: PropTypes.string,
    imagePosition: PropTypes.string,
    superSizeTitle: PropTypes.bool,
};
